const FORBIDDEN = '403';
const NOT_FOUND = '404';

export const SYSTEM_ROUTES = {
  FORBIDDEN,
  NOT_FOUND,
};
